<template>
  <div class="absolute inset-0 w-full h-full">
    <ColorBends
      :colors="['#ff5c7a', '#8a5cff', '#00ffd1']"
      :rotation="0"
      :speed="0.2"
      :scale="1.0"
      :frequency="1.0"
      :warp-strength="1.0"
      :mouse-influence="1.0"
      :parallax="0.4"
      :noise="0.1"
      :transparent="false"
    />
  </div>
</template>

<script setup>
  import ColorBends from './ColorBends.vue'
</script>
